
import * as React from "react";

import { TableHead, TableHeadCell, IconTable } from "@wg/wows-react-uikit";

import headers from "./headers.settings";

export type IClansRatingTableHead_Props = {
  stickyContainerId: string;
};
export type IClansRatingTableHead_State = {};

class ClansRatingTableHead extends React.PureComponent<IClansRatingTableHead_Props, IClansRatingTableHead_State> {
  render() {
    // @ts-ignore
    return <TableHead stickyContainerId={this.props.stickyContainerId} isActiveSticky={false}>
      {/* @ts-ignore */}
      {headers().map((item, index) => {
        return (
          // @ts-ignore
          <TableHeadCell key={index} modify={item.modify} isHidden={item.isHidden}>
            {/* @ts-ignore */}
            {item.glyph ? <IconTable glyph={item.glyph} /> : null}
            {item.text}
          </TableHeadCell>
        )
      })}
    </TableHead>;
  }
}

export default ClansRatingTableHead;